/**
 * Namespace Service
 *
 * Manages the data attribute namespace prefix used throughout Kendo UI.
 * This allows customization of data-role attributes (e.g., data-kendo-role instead of data-role).
 */

import type { INamespaceService } from "../models/namespace";

export class NamespaceService implements INamespaceService {
    private _ns: string = "";

    /**
     * Get the current namespace prefix
     */
    get ns(): string {
        return this._ns;
    }

    /**
     * Set the namespace prefix
     * @param value - The namespace prefix (e.g., "kendo-")
     */
    setNs(value: string): void {
        this._ns = value;
    }
}
